const elements = {
  link: 'a.smooth-scroll',
  comments: '#c-comments',
}

export default {
  init() {
    $(document).ready(() => {
      $(elements.link).each(function () {
        $(this).click((event) => {
          event.preventDefault();
          $('html, body').animate({
              scrollTop: $($(this).attr('href')).offset().top
          }, 1000);
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/smooth-anchor.js